import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CryptoLaunchpadHero from "./CryptoLaunchpadHero";
import WhatIsCryLPad from "./WhatIsCryLPad";
import ProjectVerification from "./ProjectVerification";
import EarlyAccess from "./EarlyAccess";
import PlatformStrategy from "./PlatformStrategy";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function CryptoLaunchpad() {
  return (
    <div>
      <Header />
      <CryptoLaunchpadHero />
      <WhatIsCryLPad />
      <ProjectVerification />
      <EarlyAccess />
      <PlatformStrategy />
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default CryptoLaunchpad;
